@if (variant !== 'checkout') {
  <div class="modal-header survey-header" [ngClass]="iconTypeLayoutClass()">
    <span class="survey-spacer" aria-hidden="true"></span>
    <span class="survey-title">{{ surveyDisplayTitle }}</span>
    @if (!forceAnswer) {
      <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
        <img src="/assets/images/bt-close.svg" />
      </button>
    } @else {
      <span class="survey-spacer" aria-hidden="true"></span>
    }
  </div>

  @if (exists(iframeSrc)) {
    <div class="modal-body survey-body" [class.survey-body--ready]="surveyReady">
      @if (!surveyReady) {
        <span class="survey-loading" aria-hidden="true">
          <i class="fas fa-spinner"></i>
        </span>
      }
      <iframe [src]="iframeSrc" scrolling="yes" (load)="checkToClose($event)"></iframe>
    </div>
  }

  <div class="modal-footer survey-footer">
    @if (forceAnswer) {
      <span class="survey-footer__text">{{ surveyRequiredNotice }}</span>
    }
  </div>
} @else {
  <div class="transparent-modal absolute-content" [style.height.px]="checkoutHeightPx">
    <div class="modal-header" [ngClass]="iconTypeLayoutClass()">
      <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
        <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
      </button>
    </div>

    @if (exists(iframeSrc)) {
      <div class="modal-body">
        <iframe [src]="iframeSrc" scrolling="yes" (load)="checkToClose($event)"></iframe>
      </div>
    }
  </div>
}
